import { render, staticRenderFns } from "./PropertyRiskAssessmentList.vue?vue&type=template&id=066a5179&scoped=true"
import script from "./PropertyRiskAssessmentList.vue?vue&type=script&lang=js"
export * from "./PropertyRiskAssessmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a5179",
  null
  
)

export default component.exports